import subtract from 'src/assets/images/user-mobile/Subtract.svg';
import { styled } from 'styled-components';
// import { useState } from 'react';

export default function NumberofTickets({
  count,
  setCount,
}: {
  count: number;
  setCount: (val: number) => void;
}) {
  // const [count, setCount] = useState(1);

  const onIncrease = () => {
    if (count < 2) {
      setCount(count + 1);
    }
  };

  const onDecrease = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  return (
    <TicketNumberContainer>
      <TitleWrapper>
        <Title>입장권 매수 선택</Title>
        <Notice>
          <span>최대 2매</span>까지 예매 가능
        </Notice>
      </TitleWrapper>
      <TicketCountWrapper>
        <CountButton onClick={onDecrease} disabled={count === 1}>
          <TicketCount src={subtract} alt="-" isDisabled={count === 1} />
        </CountButton>
        <TicketNumber>{count}매</TicketNumber>
        <CountButton onClick={onIncrease} disabled={count === 2}>
          <TicketCount
            src={subtract} // subtract 이미지 그대로 사용
            alt="+"
            isDisabled={count === 2}
            // eslint-disable-next-line react/jsx-boolean-value
            rotate={true} // 180도 회전
          />
        </CountButton>
      </TicketCountWrapper>
    </TicketNumberContainer>
  );
}

const TicketNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TitleWrapper = styled.div`
  margin: 20px auto auto;
`;

const Title = styled.div`
  color: #111;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.45px;
`;
const Notice = styled.div`
  color: #555;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.35px;
  span {
    color: #c6187e;
    font-weight: 600;
  }
`;
const TicketCountWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const TicketNumber = styled.div`
  width: 48px;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid #0b2873;
  background: #fff;

  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.04px;
  flex-shrink: 0;
`;

const CountButton = styled.button<{ disabled?: boolean }>`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 6px;
  background: ${({ disabled }) => (disabled ? '#B5BED9' : '#0B2873')};
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

const TicketCount = styled.img<{ isDisabled?: boolean; rotate?: boolean }>`
  width: 15px;
  height: 20px;
  filter: ${({ isDisabled }) =>
    isDisabled
      ? 'brightness(0) saturate(100%) invert(92%) sepia(4%) saturate(11%) hue-rotate(336deg) brightness(99%) contrast(89%)'
      : 'none'};
  transform: ${({ rotate }) => (rotate ? 'rotate(180deg)' : 'none')};
`;
